import { Injectable, inject } from '@angular/core';
import { OpenIdConfiguration, StsConfigLoader } from 'angular-auth-oidc-client';
import { Observable, of } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { createOidcConfig } from './oidc-config.factory';

/**
 * Custom OIDC configuration loader.
 * Loads OIDC configuration from AppConfigService instead of hardcoding values.
 *
 * This loader is used by angular-auth-oidc-client to dynamically load
 * the OIDC configuration after the application configuration has been loaded.
 */
@Injectable()
export class OidcConfigLoader implements StsConfigLoader {
  private readonly _appConfigService = inject(AppConfigService);

  /**
   * Loads the OIDC configuration.
   * @returns Observable of OpenIdConfiguration
   */
  public loadConfigs(): Observable<OpenIdConfiguration[]> {
    const oidcConfig = createOidcConfig(this._appConfigService);
    return of([oidcConfig]);
  }
}
